export const SET_DESTINATION_NUMBER = "SET_DESTINATION_NUMBER";
export const ADD_DIGIT_TO_DESTINATION_NUMBER = "ADD_DIGIT_TO_DESTINATION_NUMBER";

export const UPDATE_CALL_INFORMATION = "UPDATE_CALL_INFORMATION";
export const UPDATE_MUTE_STATUS = "UPDATE_MUTE_STATUS";

export const DEV_PHONE_NUMBER_SELECTED = "DEV_PHONE_NUMBER_SELECTED";
export const CONFIGURE_NUMBER_IN_USE = "CONFIGURE_NUMBER_IN_USE";
export const DEV_PHONE_CONFIG_ERROR = "DEV_PHONE_CONFIG_ERROR";

export const REQUEST_CLIENT_TOKEN = "REQUEST_CLIENT_TOKEN";
export const REQUEST_CLIENT_TOKEN_SUCCESS = "REQUEST_CLIENT_TOKEN_SUCCESS";
export const REQUEST_CLIENT_TOKEN_ERROR = "REQUEST_CLIENT_TOKEN_ERROR";

export const REQUEST_CHANNEL_DATA = "REQUEST_CHANNEL_DATA";
export const REQUEST_CHANNEL_DATA_SUCCESS = "REQUEST_CHANNEL_DATA_SUCCESS";
export const REQUEST_CHANNEL_DATA_ERROR = "REQUEST_CHANNEL_DATA_ERROR";
